import { axios } from '@/services/axios';

const getLocationByID = (locationId) => {
    return axios.get(`/trunklocation/${locationId}`);
};

export default getLocationByID;
